import React, { useState } from 'react'
import './PropertyBaseMenu.scss'
import { Link } from 'gatsby'
import DatePicker from 'react-datepicker'

import 'react-datepicker/dist/react-datepicker.css'

import Drawer from '../Drawer/Drawer'
import FloatingLabelInput from 'react-floating-label-input'

import { isEmail, isContact } from '../../components/Helpers/helpers'

import { graphql, useStaticQuery } from 'gatsby'

import SubmitApplication from '../../templates/Careers/SubmittedApplication'
import axios from 'axios'

import { useQueryPropertyByBrand } from '../../hooks/query-graphql'

import { alphaOnly, numericOnly, preventInput } from '../../components/Common/Validator'

let ALISI_BRAND_ID: any = process.env.GATSBY_API_ALISI_BRAND_ID
let API_URL: any = process.env.GATSBY_API_URL

interface errorProps {
  firstName?: string | null
  lastName?: string | null
  email?: string | null
  phoneNumber?: string | null
  date?: string | null
  general?: string | null
  terms?: string | null
}

const PropertyBaseMenu = (props: any) => {
  const pageContext = props.pageData && props.pageData.pageContext
  const property = pageContext ? pageContext.property : {}
  const pageLocation = props.pageData.location.pathname
  const { brand, id, name, unitLinkBtn } = property.details

  const properties = useQueryPropertyByBrand(brand, id)

  const indexProperty = (): number => {
    let tempIndex = 0
    properties.map((resProperty: any, indexProp: number) =>
      resProperty.context.property.details.id === id ? (tempIndex = indexProp) : null
    )
    return tempIndex
  }

  const [index, setIndex] = useState(indexProperty)

  const [terms, setTerms] = useState<boolean>(false)

  const handleTerms = async () => {
    setErrors((oldErrors) => ({
      ...oldErrors,
      terms: null
    }))
    setTerms(!terms)
  }

  const indexCount = index + 1

  const prevIndex = index === 0 ? properties.length - 1 : index - 1

  const nextIndex = indexCount === properties.length ? 0 : indexCount

  let propertyLinks = ['overview', 'location', 'units-and-floor-plans', 'features-and-amenities', 'construction-updates']

  if (pageContext.brand === 'alp') {
    propertyLinks = ['overview', 'location', 'units-and-floor-plans']
  }

  const currentPropertyTab = pageLocation.split('/')[3]

  const rightArrowLink = () => {
    let rightLink = ''
    let pagePath = pageLocation
    if (propertyLinks.indexOf(currentPropertyTab) === propertyLinks.length - 1) {
      rightLink = pagePath
    } else {
      let nextLink = pagePath.split('/')
      nextLink[3] = propertyLinks[propertyLinks.indexOf(currentPropertyTab) + 1]
      rightLink = nextLink.join('/')
    }
    return rightLink
  }

  const leftArrowLink = () => {
    let leftLink = ''
    let pagePath = pageLocation
    if (propertyLinks.indexOf(currentPropertyTab) === 0) {
      leftLink = pagePath
    } else {
      let nextLink = pagePath.split('/')
      nextLink[3] = propertyLinks[propertyLinks.indexOf(currentPropertyTab) - 1]
      leftLink = nextLink.join('/')
    }
    return leftLink
  }

  const menuLinks = useStaticQuery(graphql`
    query externalLinks {
      externalLinks {
        links {
          id
          link
          category
          name
          image
        }
      }
    }
  `)

  const calculatorData = menuLinks.externalLinks.links.filter((x: any) => x.name === 'Calculator')[0]

  const [visitDrawer, setVisitDrawer] = useState<boolean>(false)
  const [submitting, setSubmitting] = useState<boolean>(false)
  const [submitted, setSubmitted] = useState<boolean>(false)
  const [errors, setErrors] = useState<errorProps>({})
  const [date, setDate] = useState<any>(null)

  const today = new Date()
  const month = today.getMonth()
  const year = today.getFullYear()
  const tomorrow = new Date(today.setDate(today.getDate() + 1))
  const maxMonth = month + 6 > 12 ? new Date(today.setMonth(6 - (12 - month))) : new Date(today.setMonth(month + 6))
  const maxDate = month + 6 > 12 ? new Date(maxMonth.setFullYear(year + 1)) : maxMonth

  const [fields, setFields] = useState({
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    propertyName: property.details.name
  })

  const handleChange = (events: any) => {
    events.persist()

    let name = events.target.name
    let value = events.target.value

    setErrors((oldErrors) => ({
      ...oldErrors,
      [name]: null
    }))
    setFields((oldFields) => ({
      ...oldFields,
      [name]: value
    }))
  }

  const handleSubmit = () => {
    const fieldsError: any = {}

    if (fields.firstName.trim() === '') {
      fieldsError.firstName = 'This field is required!'
    }

    if (fields.lastName.trim() === '') {
      fieldsError.lastName = 'This field is required!'
    }

    if (!isEmail(fields.email)) {
      fieldsError.email = 'Please provide a proper email address.'
    }

    if (!isContact(fields.phoneNumber)) {
      fieldsError.phoneNumber = 'Please provide a proper contact number.'
    }

    if (!date) {
      fieldsError.date = 'This field is required!'
    }

    if (!terms) {
      fieldsError.terms = 'You must Agree to the Terms and Conditions and Privacy Notice'
    }

    if (Object.keys(fieldsError).length === 0) {
      setSubmitting(true)

      let visitData = { brandId: ALISI_BRAND_ID, ...fields, date: date }

      axios({
        method: 'post',
        url: `${API_URL}/schedule-visit`,
        data: visitData
      })
        .then((res: any) => {
          setSubmitted(true)
        })
        .catch((err: any) => {
          fieldsError.general = 'Submission Failed! Please try again later.'
          setErrors(fieldsError)
          setSubmitting(false)
        })
    } else {
      setErrors(fieldsError)
    }
  }

  const handleReset = () => {
    setFields({
      firstName: '',
      middleName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      propertyName: property.details.name
    })
    setDate(null)
    setSubmitting(false)
    setSubmitted(false)
  }

  const handleDate = async (date: any) => {
    await setErrors((oldErrors) => ({
      ...oldErrors,
      date: null
    }))

    setDate(date)
  }

  const handleClose = async () => {
    await handleReset()
    await setErrors({})
    setVisitDrawer(false)
  }

  return (
    <>
      <div className="property-base-menu base-menu">
        <div className="menu-group">
          <Link to={properties[prevIndex].path}>
            <div className="arrow left">
              <i className="la la-arrow-left" />
            </div>
          </Link>

          <div className="text-item">
            <span>
              <i className="la la-map-marker" /> {property.details.location}
            </span>
          </div>

          <div className="text-item">
            <span>
              <i className="la la-tag" />
              {property.details.status ? property.details.status : 'Pre Selling'}
            </span>
          </div>
        </div>

        <div className="menu-group">
          <div className="text-item" onClick={() => setVisitDrawer(true)}>
            <button className="btn-outline">
              <i className="la la-calendar-check" /> Schedule a Visit
            </button>
          </div>

          <Link to={calculatorData ? calculatorData.link : ''} target="_blank">
            <div className="text-item">
              <button className="btn-outline">
                <i className="la la-calculator" /> Loan Calculator
              </button>
            </div>
          </Link>
          {unitLinkBtn ? (
            <a href={unitLinkBtn} target="_blank">
              <div className="text-item">
                <button className="btn-active">Reserve Now</button>
              </div>
            </a>
          ) : (
            <Link to="/contact-us">
              <div className="text-item">
                <button className="btn-active">Reserve Now</button>
              </div>
            </Link>
          )}
          <Link to={properties[nextIndex].path}>
            <div className="arrow right">
              <i className="la la-arrow-right" />
            </div>
          </Link>
        </div>
      </div>

      {visitDrawer && (
        <>
          <Drawer onClose={handleClose} noPaddingX={true} style={{ width: '455px' }}>
            {!submitted ? (
              <div className="visit-drawer-container">
                <h1>Schedule a visit</h1>

                {errors.general && (
                  <small className="field-error fade-in">
                    <i className="la la-exclamation-circle" /> {errors.general}
                  </small>
                )}

                <div className="forms-container">
                  <div className={`floating-input ${errors.firstName && 'error'}`}>
                    <FloatingLabelInput
                      onPaste={preventInput}
                      name="firstName"
                      value={fields.firstName}
                      label="First Name"
                      onChange={(e: any) => {
                        const isAplha = alphaOnly(e)
                        if (!isAplha) {
                          return
                        }
                        handleChange(e)
                      }}
                    />
                  </div>
                  {errors.firstName && (
                    <small className="field-error fade-in">
                      <i className="la la-exclamation-circle" /> {errors.firstName}
                    </small>
                  )}

                  <div className={`floating-input`}>
                    <FloatingLabelInput
                      onPaste={preventInput}
                      name="middleName"
                      value={fields.middleName}
                      label="Middle Name"
                      onChange={(e: any) => {
                        const isAplha = alphaOnly(e)
                        if (!isAplha) {
                          return
                        }
                        handleChange(e)
                      }}
                    />
                  </div>

                  <div className={`floating-input ${errors.lastName && 'error'}`}>
                    <FloatingLabelInput
                      onPaste={preventInput}
                      name="lastName"
                      value={fields.lastName}
                      label="Last Name"
                      onChange={(e: any) => {
                        const isAplha = alphaOnly(e)
                        if (!isAplha) {
                          return
                        }
                        handleChange(e)
                      }}
                    />
                  </div>
                  {errors.lastName && (
                    <small className="field-error fade-in">
                      <i className="la la-exclamation-circle" /> {errors.lastName}
                    </small>
                  )}

                  <div className={`floating-input ${errors.email && 'error'}`}>
                    <FloatingLabelInput name="email" value={fields.email} onChange={handleChange} label="Email Address" />
                  </div>
                  {errors.email && (
                    <small className="field-error fade-in">
                      <i className="la la-exclamation-circle" /> {errors.email}
                    </small>
                  )}

                  <div className={`floating-input ${errors.phoneNumber && 'error'}`}>
                    <FloatingLabelInput
                      onPaste={preventInput}
                      name="phoneNumber"
                      value={fields.phoneNumber}
                      label="Phone Number"
                      onChange={(e: any) => {
                        const isNumeric = numericOnly(e)
                        if (!isNumeric) {
                          return
                        }
                        handleChange(e)
                      }}
                    />
                  </div>
                  {errors.phoneNumber && (
                    <small className="field-error fade-in">
                      <i className="la la-exclamation-circle" /> {errors.phoneNumber}
                    </small>
                  )}

                  <div className={`floating-input  disable`}>
                    <FloatingLabelInput disable name="property" value={fields.propertyName} label="Property" />
                  </div>

                  <div className={`floating-input ${errors.date && 'error'} date-picker`}>
                    <DatePicker
                      selected={date}
                      onChange={(date: any) => handleDate(date)}
                      dateFormat="MMMM dd, yyyy"
                      placeholderText="Select Date"
                      minDate={tomorrow}
                      maxDate={maxDate}
                    />
                  </div>
                  {errors.date && (
                    <small className="field-error fade-in">
                      <i className="la la-exclamation-circle" /> {errors.date}
                    </small>
                  )}
                  <div className="form-agreement">
                    <div className="terms-checkbox" onClick={() => handleTerms()}>
                      {terms && <i className="la la-check" />}
                    </div>
                    <span>
                      I have read and agreed with the <a href="/privacy-notice">Privacy Notice</a> and{' '}
                      <a href="/terms-and-conditions">Terms and Conditions</a>
                    </span>
                  </div>
                </div>
                {errors.terms && (
                  <small className="field-error fade-in">
                    <i className="la la-exclamation-circle" /> {errors.terms}
                  </small>
                )}
              </div>
            ) : (
              <SubmitApplication name={fields.firstName} label="Visit" mode="scheduled-visit" />
            )}
          </Drawer>
          {!submitted && (
            <button className={`submit-button slide-in-right ${submitting ? 'disabled' : ''}`} onClick={handleSubmit}>
              <span>{submitting ? 'Submitting...' : 'Submit'}</span>
            </button>
          )}
        </>
      )}
    </>
  )
}

export default PropertyBaseMenu
